import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const StyledCardWarningDiv = styled.div`
  background-color: #fff8e1;
  color: #ffab00;
`

const CardWarning = ({children, ...otherProps}) => <StyledCardWarningDiv {...otherProps}>{children}</StyledCardWarningDiv>

CardWarning.propTypes = {
  children: PropTypes.any
}

export {CardWarning}
